import Strings from "src/shared/Strings";
export const isBuiltStepData = (element) => {
    return element instanceof BuiltStepData;
};
export class BuiltStepData {
    constructor(response, context) {
        this.id = response.id;
        this.name = response.name;
        this.value = response.value;
        this.scope = response.scope;
        this.dimension = response.dimension;
        this.persist_types = response.persist_types;
        this.default_value = response.default_value;
        this.key_type = response.key_type;
        this.enabled = response.enabled;
        this.component_ids = response.component_ids;
        this.context = context;
    }
    getDisplayName() {
        return Strings.capitalize(this.name);
    }
    static fromJSON(json, context) {
        return new BuiltStepData(json, context);
    }
    toJSON() {
        return {
            id: this.id,
            name: this.name,
            value: this.value,
            scope: this.scope,
            dimension: this.dimension,
            persist_types: this.persist_types,
            default_value: this.default_value,
            key_type: this.key_type,
            enabled: this.enabled,
            component_ids: this.component_ids,
        };
    }
    static instanceof(obj) {
        return obj instanceof BuiltStepData;
    }
}
